import { dew as _getFormDataContentLengthDew } from "./getFormDataContentLength";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getFormDataContentLength = void 0;
  var getFormDataContentLength_1 = _getFormDataContentLengthDew();
  Object.defineProperty(exports, "getFormDataContentLength", {
    enumerable: true,
    get: function () {
      return getFormDataContentLength_1.getFormDataContentLength;
    }
  });
  return exports;
}